"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const use_field_api_1 = __importDefault(require("@data-driven-forms/react-form-renderer/use-field-api"));
const FormField_1 = __importDefault(require("../../../FormField"));
const DatePicker_1 = __importDefault(require("../../../DatePicker"));
const useUniqueId_1 = __importDefault(require("../../../../hooks/useUniqueId"));
const getErrorText_1 = require("../../utils/getErrorText");
const DatepickerMapping = (props) => {
    const _a = use_field_api_1.default(props), { label, description, helperText, isRequired, isDisabled, isReadOnly, placeholder, input, validateOnMount, stretch, showError, meta: { error, submitFailed } } = _a, rest = __rest(_a, ["label", "description", "helperText", "isRequired", "isDisabled", "isReadOnly", "placeholder", "input", "validateOnMount", "stretch", "showError", "meta"]);
    const controlId = useUniqueId_1.default(input.name);
    const errorText = getErrorText_1.getErrorText(validateOnMount, submitFailed, showError, error);
    return (react_1.default.createElement(FormField_1.default, { controlId: controlId, label: label, description: description, hintText: helperText, errorText: errorText, stretch: stretch },
        react_1.default.createElement(DatePicker_1.default, Object.assign({}, rest, input, { placeholder: placeholder, controlId: controlId, disabled: isDisabled, ariaRequired: isRequired, readOnly: isReadOnly, invalid: !!errorText }))));
};
exports.default = DatepickerMapping;
//# sourceMappingURL=index.js.map